const UI_DISPLAY_LANGUAGES = {
  GERMAN: "de",
  ENGLISH: "en",
  FRENCH: "fr",
  ITALIAN: "it",
} as const

const UI_CURRENT_LANGUAGE = "currentLanguage"

type UiDisplayLanguage = (typeof UI_DISPLAY_LANGUAGES)[keyof typeof UI_DISPLAY_LANGUAGES]

export { UI_DISPLAY_LANGUAGES, UI_CURRENT_LANGUAGE, type UiDisplayLanguage }
